
// Collection main page filter - OPEN ONLY ONE ACCORDION 

document.addEventListener("toggle", function (e) {

  const opened = e.target;
  if (!opened.classList.contains("accordion__disclosure")) return;

  if (!opened.open) return;

  const container = opened.closest(".accordion-list");
  if (!container) return;

  container.querySelectorAll(".accordion__disclosure").forEach((acc) => {

    if (acc !== opened && acc.open) {

      const summary = acc.querySelector("summary");

      // simulate real user close (VERY IMPORTANT)
      if (summary) {
        summary.click();
      }

    }

  });

}, true);

(function () {
  /* ------------------------------
     CLICK OUTSIDE ACCORDION CLOSE 
  --------------------------------*/
  document.addEventListener("click", function (e) {

    if (e.target.closest(".accordion-list")) return;

    document.querySelectorAll(".accordion-list .accordion__disclosure[open]")
      .forEach(acc => acc.querySelector("summary")?.click());

  }, true);
  /* ------------------------------
     ESC KEY ACCORDION CLOSE
  --------------------------------*/
  document.addEventListener("keydown", function (e) {

    if (e.key !== "Escape") return;

    document.querySelectorAll(".accordion-list .accordion__disclosure[open]")
      .forEach(acc => acc.querySelector("summary")?.click());

  });

})();

/*review badge*/

document.addEventListener("DOMContentLoaded", function () {

  function insertCustomRating() {
    const badge = document.querySelector('.jdgm-prev-badge');
    if (!badge) return;

    const textEl = badge.querySelector('.jdgm-prev-badge__text');

    let rating = 0;
    let count = 0;

    if (textEl) {
      const matches = textEl.innerText.match(/([\d.]+).*?(\d+)/);
      if (matches) {
        rating = matches[1];
        count = matches[2];
      }
    }

    // Select ALL gallery media items, not just the active one
    const allMedia = document.querySelectorAll('.product-gallery__media');

    if (!allMedia.length) return;

    allMedia.forEach(function (mediaItem) {
      // Remove existing overlay to avoid duplicates
      mediaItem.querySelectorAll('.custom-rating-overlay').forEach(el => el.remove());

      const overlay = document.createElement('div');
      overlay.className = 'custom-rating-overlay';

      if (count > 0) {
        overlay.innerHTML = `
          <span class="rating-star">★</span>
          <span class="rating-value">${rating}</span>
          <span class="rating-divider">|</span>
          <span class="rating-count">${count}</span>
        `;
      } else {
        overlay.innerHTML = `
          <span class="rating-star">★</span>
        `;
      }

      overlay.addEventListener("click", function () {
        const reviewSection = document.querySelector(
          '.jdgm-carousel-wrapper, #judgeme_product_reviews'
        );
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: "smooth" });
        }
      });

      mediaItem.style.position = "relative";
      mediaItem.appendChild(overlay);
    });
  }

  setTimeout(insertCustomRating, 1000);

  document.addEventListener("variant:changed", function () {
    setTimeout(insertCustomRating, 600);
  });

});

/* Mouse Move Zoom in product page*/

document.querySelectorAll('.product-gallery__media').forEach(function(container) {

  const img = container.querySelector('img');
  if (!img) return;

  let zoomActive = false;

  container.addEventListener('click', function(e) {

    // Prevent conflict with swipe
    if (e.target.closest('button')) return;

    zoomActive = !zoomActive;

    container.classList.toggle('zoom-active');

    if (!zoomActive) {
      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center center";
    }
  });

  container.addEventListener('mousemove', function(e) {

    if (!zoomActive) return;

    const rect = container.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    img.style.transformOrigin = x + "% " + y + "%";
    img.style.transform = "scale(2)";
  });

});




document.addEventListener("DOMContentLoaded", function(){

  const reviewWrapper = document.querySelector(".jdgm-rev-widg__reviews");

  if(!reviewWrapper) return;

  reviewWrapper.classList.add("swiper");

  const reviews = reviewWrapper.querySelectorAll(".jdgm-rev");

  const swiperWrapper = document.createElement("div");
  swiperWrapper.classList.add("swiper-wrapper");

  reviews.forEach(review=>{
      review.classList.add("swiper-slide");
      swiperWrapper.appendChild(review);
  });

  reviewWrapper.appendChild(swiperWrapper);

  const pagination = document.createElement("div");
  pagination.classList.add("swiper-pagination");

  reviewWrapper.appendChild(pagination);

  new Swiper(".jdgm-rev-widg__reviews.swiper",{
      slidesPerView:1,
      spaceBetween:20,
      loop:true,
      autoplay:{
        delay:4000
      },
      pagination:{
        el:".swiper-pagination",
        clickable:true
      },
      breakpoints:{
        768:{
          slidesPerView:1
        },
        1024:{
          slidesPerView:2
        }
      }
  });

});
